import metricMapping from '@/services/experienceScore/mappings/metricMapping';
import routerService from '@/services/route/routerService';

const INSIGHT_PARAM = 'insight';
const INFO_PARAM = 'info';
const SCORE_INFO_VALUE = 'score';

const parse = (search: string) => {
    const params = new URLSearchParams(search);
    const insightId = params.get(INSIGHT_PARAM);
    const infoValue = params.get(INFO_PARAM);

    return {
        insightId,
        isDetailOpen: insightId !== null,
        infoCode: infoValue && infoValue !== SCORE_INFO_VALUE ? infoValue : undefined,
        isInfoOpen: infoValue !== null,
        isAnyOpen: insightId !== null || infoValue !== null,
    };
};

// Without authored content a layer would open blank, so it does not open at all.
const openDetail = (insightId: string) => {
    if (!metricMapping.hasDetail(insightId)) return;

    const params = new URLSearchParams(routerService.getSearch());

    params.set(INSIGHT_PARAM, insightId);
    params.delete(INFO_PARAM);
    routerService.push(params.toString());
};

const openInfo = (code?: string) => {
    if (!metricMapping.hasExplanation(code)) return;

    const params = new URLSearchParams(routerService.getSearch());

    params.set(INFO_PARAM, code ?? SCORE_INFO_VALUE);
    routerService.push(params.toString());
};

const closeTop = () => routerService.pop(1);

const closeAll = () => routerService.pop(routerService.getDepth());

const reset = () => routerService.replace('');

export default {parse, openDetail, openInfo, closeTop, closeAll, reset};
